import React from 'react';
import {
    Button,
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
    UncontrolledButtonDropdown,
} from 'reactstrap';

export default function ButtonGroupRoles(props) {
    const { roles, group, goToGroup } = props;

    let layout;

    if (roles) {
        if (roles.length === 1) {
            const role = roles[0];
            layout = (
                <div className="btn-group">
                    <Button
                        className="btn-wide mb-2 mr-2"
                        color="primary"
                        onClick={() => goToGroup(role.label, group, role.code)}
                    >
                        Open
                    </Button>
                </div>
            );
        } else {
            layout = (
                <UncontrolledButtonDropdown>
                    <DropdownToggle
                        className="btn-wide mb-2 mr-2"
                        caret
                        color="primary"
                    >
                        Open As
                    </DropdownToggle>
                    <DropdownMenu>
                        {roles.map((role) => (
                            <DropdownItem
                                key={role.code}
                                onClick={() => goToGroup(role.label, group)}
                            >
                                {role.label === 'owner' && <span>Owner</span>}
                                {role.label === 'coordinator' && (
                                    <span>Coordinator</span>
                                )}
                                {role.label === 'giver' && (
                                    <span>Volunteer</span>
                                )}
                                {role.label === 'receiver' && (
                                    <span>Senior</span>
                                )}
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                </UncontrolledButtonDropdown>
            );
        }
    } else {
        return;
    }

    return layout;
}
